export class InvalidInputException extends Error {
	constructor(message) {
		super(message);

		// capturing the stack trace keeps the reference to your error class
		if ('captureStackTrace' in Error) {
			Error.captureStackTrace(this, this.constructor);
		} else {
			console.error(`${this.constructor.name} Does not support captureStackTrace()!`);
		}

		this.status = 400;
	}

	statusCode() {
		return this.status;
	}
}
